import React from "react";
import { Route } from "react-router-dom";
import Container from "./Container.jsx";
import PropTypes from "prop-types";
import GridQuotas from "../components/Views/GridQuotas.jsx";
import Paper from "@material-ui/core/Paper";
import { Box, Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import sortBy from "lodash/sortBy";

class RoomQuotasContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("room_quotas");
        this.getAuxData();
    }

    render = () => {
        const routes = this.datasource.routes();
        const { history } = this.props;
        const auxDataRoomTypes =
            this.props?.auxData?.room_types &&
            this.props.auxData.room_types.filter((t) => t.active);
        const sortedAux = sortBy(auxDataRoomTypes, "order");
        const auxDataRates =
            this.props?.auxData?.rates_short && this.props.auxData.rates_short;
        const gridQuotas = !auxDataRoomTypes ? (
            <Box mt={4}>
                <LinearProgress mt={3} />
            </Box>
        ) : sortedAux.length > 0 ? (
            <Box p={3}>
                <Route path={routes.home} exact>
                    <GridQuotas
                        loading={this.state.loading}
                        auxData={sortedAux}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        objectTemplate={this.datasource.getEmptyObject()}
                        submitAction={this.updateAllItems}
                        errorFields={this.state.error}
                        updateAction={this.setItems}
                        rates={auxDataRates}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        history={history}
                        openLeftMenu={this.props.openLeftMenu}
                    />
                </Route>{" "}
            </Box>
        ) : (
            <Typography>Отсутствуют внесенные категории номеров</Typography>
        );

        return (
            <>
                <Paper elevation={3}>
                    <Box
                        p={3}
                        display={"flex"}
                        justifyContent={"space-between"}
                    >
                        <Typography mb={3} variant={"h5"}>
                            Квоты номеров
                        </Typography>
                    </Box>
                    {gridQuotas}
                </Paper>
            </>
        );
    };
}

RoomQuotasContainer.propTypes = {
    auxEntity: PropTypes.array.isRequired,
    auxSource: PropTypes.func.isRequired,
    auxData: PropTypes.object.isRequired,
};

export default RoomQuotasContainer;
